import { QuickStatsCard } from "@features/cx/shared/components/QuickStatsCard";
import { Layers, CheckCircle2, XCircle } from "lucide-react";
import React from "react";
export const Dashboard: React.FC<{ kpi?: any }> = ({ kpi }) => {
  const cards = [
    {
      title: "Total GL Codes",
      count: kpi?.total || 0,
      icon: (
        <div className="bg-blue-50 w-full h-full rounded-xl flex items-center justify-center">
          <Layers className="h-5 w-5 text-blue-600" />
        </div>
      ),
    },
    {
      title: "Active",
      count: kpi?.active || 0,
      icon: (
        <div className="bg-green-100 w-full h-full rounded-xl flex items-center justify-center">
          <CheckCircle2 className="h-5 w-5 text-green-600" />
        </div>
      ),
    },
    {
      title: "Inactive",
      count: kpi?.inactive || 0,
      icon: (
        <div className="bg-red-50 w-full h-full rounded-xl flex items-center justify-center">
          <XCircle className="h-5 w-5 text-red-600" />
        </div>
      ),
    },
  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mt-4">
      {cards.map((card, index) => (
        <QuickStatsCard
          key={index}
          title={card.title}
          count={card.count}
          icon={card.icon}
        />
      ))}
    </div>
  );
};
